export default __webpack_public_path__ + "static/media/morricana.0e8f28a4.webp";